import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    VStack,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    formInputStyles,
} from 'components/forms/new/formStyles';
import NameField from '@/components/forms/new/formikFormFields/NameField';

const DialPlanNameField = ({ darkMode, errors, touched, isEdit, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            isInvalid={!!errors.name && touched.name}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            isRequired>
            <Stack
                direction="row"
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <Box w="200px">
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Dial Plan Name
                    </FormLabel>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            id="name"
                            name="name"
                            placeholder="Enter dial plan name"
                            validate={(value) =>
                                !value && 'Dial Plan Name is required'
                            }
                            {...props}
                        />
                        <FormErrorMessage>{errors.name}</FormErrorMessage>
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label={
                            isEdit
                                ? 'Edit the dial plan name.'
                                : 'Please enter a dial plan name to identify in the future.'
                        }
                        ariaLabel="dial plan name tooltip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default DialPlanNameField;
